export const vns_monitor_tipo                = ['vns_monitor.tipo']
export const vns_monitor_service_queue       = ['vns_monitor.service_queue']
export const vns_monitor_tipo_info           = ['vns_monitor.tipo_info']
export const vns_monitor_tipo_latency        = ['vns_monitor.tipo_latency']
export const vns_monitor_tipo_temperature    = ['vns_monitor.tipo_temperature']
export const vns_monitor_tipo_location       = ['vns_monitor.tipo_location']
export const vns_monitor_tipo_jira           = ['vns_monitor.tipo_jira']
export const vns_monitor_observation         = ['vns_monitor.observation']
export const vns_monitor_observation_support = ['vns_monitor.observation_support']
export const vns_monitor_observation_lis     = ['vns_monitor.observation_lis']

export default [].concat(
    vns_monitor_tipo,
    vns_monitor_service_queue,
    vns_monitor_tipo_info,    
    vns_monitor_tipo_latency,
    vns_monitor_tipo_temperature,
    vns_monitor_tipo_location,
    vns_monitor_observation,
    vns_monitor_observation_support,
    vns_monitor_observation_lis,
    vns_monitor_tipo_jira
)
